// extracted by mini-css-extract-plugin
module.exports = {"row":"_c86dc3b","unsupported":"_ecffe9a"};